import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { PageTipoDebito, TipoDebitoManutencaoRequest, TipoDebitoManutencaoResponse } from './tipo-debito.model';

@Injectable({ providedIn: 'root' })
export class TipoDebitoService extends BaseService {
    private readonly PATH = SICOM_PATHS.financeiro.arrecadacao.tipoDebito;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarTodos(): Observable<TipoDebitoManutencaoResponse[]> {
        return this.http.get<TipoDebitoManutencaoResponse[]>(`${this.rootUrl}${this.PATH}`);
    }

    buscarPorId(id: string): Observable<TipoDebitoManutencaoResponse> {
        return this.http.get<TipoDebitoManutencaoResponse>(`${this.rootUrl}${this.PATH}/${id}`);
    }

    salvar(request: TipoDebitoManutencaoRequest): Observable<TipoDebitoManutencaoResponse> {
        return this.http.post<TipoDebitoManutencaoResponse>(`${this.rootUrl}${this.PATH}`, request);
    }

    /**
     * Pesquisa tipos de débito com filtros opcionais de texto, UF e tipo, e suporte a paginação e ordenação.
     * Omite parâmetros vazios para evitar envio desnecessário ao backend.
     * @param q Texto livre para filtrar por descrição ou código do tipo de débito.
     */
    pesquisar(q: string, sgUf = '', tipo = '', page = 0, size = 20, sort = 'id_tpdebito', direction: 'asc' | 'desc' = 'asc'): Observable<PageTipoDebito> {
        let params = new HttpParams().set('page', page).set('size', size).set('sort', sort).set('direction', direction);
        if (q && q.trim()) params = params.set('q', q.trim());
        if (sgUf && sgUf.trim()) params = params.set('sgUf', sgUf.trim());
        if (tipo && tipo.trim()) params = params.set('tipo', tipo.trim());
        return this.http.get<PageTipoDebito>(`${this.rootUrl}${this.PATH}/pesquisar`, { params });
    }

    deletar(id: string): Observable<void> {
        return this.http.delete<void>(`${this.rootUrl}${this.PATH}/${id}`);
    }
}
